import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/_modal/WalletModal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/launchpool/_banners/NowUseYourSparksBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/launchpool/_lists/LaunchpoolList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SegmentPage"] */ "/vercel/path0/features/src/misc/segment/segment-page.tsx");
